export enum ChildOrientation {
    Vertical = 'VERTICAL',
    Horizontal = 'HORIZONTAL'
}
